module.exports = __webpack_public_path__ + "static/media/logo.1edf0603.png";